const translations = {
    agendaEmpty: 'Nothing scheduled for this day.',
    day: 'Day',
    friday: 'Fri',
    monday: 'Mon',
    month: 'Month',
    saturday: 'Sat',
    sunday: 'Sun',
    thursday: 'Thu',
    tuesday: 'Tue',
    wednesday: 'Wed',
    week: 'Week'
};

export default translations;
